// Logo lunare che segue la fase astronomica reale del giorno.
// Stesso calcolo locale del backend (daily.py): ciclo sinodico dal novilunio di
// riferimento — nessuna chiamata AI, nessuna rete, costo d'uso zero.
import { useMemo } from "react";

const SYNODIC = 29.530588853;
const REF_NEW_MOON = Date.UTC(2000, 0, 6, 18, 14); // 6 gennaio 2000, 18:14 UTC

// Le 12 varianti approvate: frazione illuminata + lato (crescente = luce a destra)
const VARIANTS = [
  { f: 0.02, wax: true },  // 00 Luna nuova
  { f: 0.12, wax: true },  // 01 Crescente giovane
  { f: 0.25, wax: true },  // 02 Luna crescente
  { f: 0.40, wax: true },  // 03 Crescente avanzata
  { f: 0.50, wax: true },  // 04 Primo quarto
  { f: 0.75, wax: true },  // 05 Gibbosa crescente
  { f: 1.00, wax: true },  // 06 Luna piena
  { f: 0.75, wax: false }, // 07 Gibbosa calante
  { f: 0.50, wax: false }, // 08 Ultimo quarto
  { f: 0.25, wax: false }, // 09 Luna calante
  { f: 0.12, wax: false }, // 10 Calante avanzata
  { f: 0.05, wax: false }, // 11 Calante anziana
];

export const currentMoonVariant = (date = new Date()) => {
  const noonUtc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 12, 0);
  const age = ((noonUtc - REF_NEW_MOON) / 86400000) % SYNODIC;
  const k = (1 - Math.cos((2 * Math.PI * age) / SYNODIC)) / 2; // frazione illuminata 0..1
  const waxing = age < SYNODIC / 2;
  let best = 0;
  let bd = Infinity;
  VARIANTS.forEach((v, i) => {
    const d = Math.abs(v.f - k) + (v.wax === waxing ? 0 : 0.5);
    if (d < bd) { bd = d; best = i; }
  });
  return best;
};

export const MoonLogo = ({ className = "w-6 h-6 rounded-full" }) => {
  const idx = useMemo(() => currentMoonVariant(), []);
  return (
    <img
      src={`/luna/fase-${String(idx).padStart(2, "0")}.png`}
      alt=""
      className={className}
      data-testid="moon-phase-logo"
    />
  );
};

export default MoonLogo;
